import type { PCOriginsModel } from './origins';
import { originsModel } from './origins';
import type { PCTenantsModel } from './tenants';
import { tenantsModel } from './tenants';

export interface PartnerConfigurationModel {
  origins: PCOriginsModel;
  tenants: PCTenantsModel;
}

export const partnerConfigurationModel: PartnerConfigurationModel = {
  origins: originsModel,
  tenants: tenantsModel,
};
